import axios from "axios";

export const getFraudRiskAccounts = async (brandUserId, params = {}) => {
    return axios
        .get("admin/fraud-risk/accounts", {
            params: { brandUserId, ...params },
        })
        .then((response) => response.data.result || [])
        .catch((error) => {
            console.error("Failed to load fraud risk accounts");
            console.error(error);
            return [];
        });
};

export const setFraudRiskReview = async (accountId, brandUserId, reviewOutcomeId) => {
    return axios
        .post(`admin/fraud-risk/accounts/${accountId}/review`, {
            brandUserId,
            reviewOutcomeId,
        })
        .then((response) => response.data)
        .catch((error) => {
            console.error("Failed to record fraud risk review");
            console.error(error);
            return { success: false, message: "Request failed." };
        });
};

// The weights and thresholds the scorer is running with right now, for the score legend.
export const getFraudRiskConfig = async () => {
    return axios
        .get("admin/fraud-risk/config")
        .then((response) => response.data.result ?? null)
        .catch((error) => {
            console.error("Failed to load fraud risk scoring config");
            console.error(error);
            return null;
        });
};
